import { createAllActions } from '@api/createRequestStore';

import * as types from './types';

export const initChart = () => ({
  type: types.INIT_CHART,
});

export const resetChart = () => ({
  type: types.RESET_CHART,
});

export const setDefaultSlice = (defaultZoom, defaultBrush) => ({
  type: types.SET_DEFAULT_SLICE,
  defaultZoom,
  defaultBrush,
});

export const setSlice = (zoom, brush) => ({
  type: types.SET_SLICE,
  zoom,
  brush,
});

export const injectSharedState = (state) => ({
  type: types.INJECT_SHARED_STATE,
  state,
});

const { init: initZoomRequest } = createAllActions(types.ZOOM_CHART_REQUEST_SCOPE);
const { init: initBrushRequest } = createAllActions(types.BRUSH_CHART_REQUEST_SCOPE);
const { init: initBrushCompareRequest } = createAllActions(types.BRUSH_COMPARE_CHART_REQUEST_SCOPE);
const { init: initSecondaryRequest } = createAllActions(types.SECONDARY_LINE_CHART_REQUEST_SCOPE);
const { init: initSecondaryCompareRequest } = createAllActions(
  types.SECONDARY_COMPARE_LINE_CHART_REQUEST_SCOPE,
);

export {
  initZoomRequest,
  initBrushRequest,
  initBrushCompareRequest,
  initSecondaryRequest,
  initSecondaryCompareRequest,
};
